import React from "react";
import { Link } from "react-router-dom";
import {
  Users,
  CalendarDays,
  Wrench,
  AlertTriangle,
  ListChecks,
  Ticket,
  ArrowUpRight,
} from "lucide-react";
import type { OverviewKpis } from "../../../types/dashboard";
import styles from "../Dashboard.module.scss";

type KpiItem = {
  key: string;
  label: string;
  value: number;
  hint?: string;
  to: string;
  icon: React.ReactNode;
  tone: string;
};

export default function KpiGrid({
  kpis,
  showTickets,
}: {
  kpis: OverviewKpis;
  showTickets: boolean;
}): JSX.Element {
  const items: KpiItem[] = [
    {
      key: "couples",
      label: "Active Couples",
      value: kpis.couplesActive,
      hint: kpis.couplesTotal ? `${kpis.couplesTotal.toLocaleString()} in directory` : undefined,
      to: "/manageCouples",
      icon: <Users size={18} color="#285d8f" />,
      tone: styles.kpiBlue,
    },
    {
      key: "open",
      label: "Registration Open",
      value: kpis.registrationOpen,
      to: "/manageRetreat",
      icon: <CalendarDays size={18} color="#0369a1" />,
      tone: styles.kpiSky,
    },
    {
      key: "setup",
      label: "In Setup",
      value: kpis.inSetup,
      to: "/manageRetreat",
      icon: <Wrench size={18} color="#b45309" />,
      tone: styles.kpiAmber,
    },
    {
      key: "closing",
      label: "Needs Closing",
      value: kpis.closing,
      to: "/manageRetreat",
      icon: <AlertTriangle size={18} color="#c2410c" />,
      tone: styles.kpiOrange,
    },
    {
      key: "waitlist",
      label: "Waitlist",
      value: kpis.waitlist,
      to: "/manageRetreat",
      icon: <ListChecks size={18} color="#15803d" />,
      tone: styles.kpiGreen,
    },
  ];

  if (showTickets) {
    items.push({
      key: "tickets",
      label: "Open Tickets",
      value: kpis.openTickets,
      to: "/tickets",
      icon: <Ticket size={18} color="#6d28d9" />,
      tone: styles.kpiPurple,
    });
  }

  return (
    <div className={`${styles.kpiGrid} ${showTickets ? "" : styles.kpiGridFive}`}>
      {items.map((item) => (
        <Link key={item.key} to={item.to} className={`${styles.kpiCard} ${item.tone}`}>
          <span className={styles.kpiTop}>
            <span className={styles.kpiIcon}>{item.icon}</span>
            <ArrowUpRight size={16} color="#9aa7b8" />
          </span>
          <span className={styles.kpiCopy}>
            <span className={styles.kpiValue}>{Number(item.value || 0).toLocaleString()}</span>
            <span className={styles.kpiLabel}>{item.label}</span>
            {item.hint ? <span className={styles.kpiHint}>{item.hint}</span> : null}
          </span>
        </Link>
      ))}
    </div>
  );
}
